import React, { useState } from 'react';
import { Spin, Form, Select, Alert } from 'antd';
import { statusesQuery, useSubmit } from '../../../../api';
import BaseModal from '../../../BaseModal/BaseModal';
import FetchError from '../../../FetchError/FetchError';
import { fieldNames } from './constants';
import { useSetModalVisible } from '../../../../model/modalState';
import InformationBlockModal from '../../../InformationBlockModal/InformationBlockModal';
import { typeMassActionsText } from '../../../InformationBlockModal/constants';

const { useFetch: useStatuses } = statusesQuery;
const { Item: FormItem, create: createForm } = Form;
const { Option } = Select;

const ErrorContent = ({ refetch }) => {
  return (
    <FetchError
      msg="Не удалось получить статусы для установки"
      onClick={() => refetch()}
    />
  );
};

const FormContainer = ({ form, requests, onSuccess }) => {
  const { validateFields, resetFields, getFieldDecorator } = form;

  const { data, isFetching, refetch } = useStatuses({
    staleTime: Infinity,
    notifyOnChangeProps: ['data', 'isFetching'],
    select: (data) =>
      !data || data === 'Error'
        ? data
        : data.sort((a, b) => a.orderNum - b.orderNum),
  });

  const { submitAsync, loading } = useSubmit({
      url: '/Request/status',
      errMsg: 'Не удалось изменить статус у выбранных заявок',
      onSuccess,
    });

  const isError = data === 'Error';

  const setModalVisible = useSetModalVisible();
   const [stateInfo, setStateInfo] = useState(false);
  const [value, setValue] = useState(null)

  const handleSubmit = (e) => {
    e.preventDefault();

    validateFields((err, values) => {
      if (!err) {
        const value = {
          StatusId: values.status,
        };

        setValue(value);
        setStateInfo(true);
      }
    });
  }

    const handleConfirmSubmit = async (e) => {
      e.preventDefault()
  
      try {
        await submitAsync({
          ids: requests.map(({ id }) => id),
          value,
          requests,
        });
  
        setModalVisible(false);
        setStateInfo(false);
        resetFields();
      } catch(error) {
        return <Alert title={error.message} />
      }
    }

 const cancelSubmit = () => {
    setStateInfo(false);
    resetFields()
  }


  return (
    <BaseModal
      title={stateInfo ? "Подтвердите изменения" : "Изменение статуса"}
      okButtonProps={{ disabled: isFetching }}
      footer={isError ? null : undefined}
      onOk={stateInfo ? handleConfirmSubmit : handleSubmit}
      onCancel={cancelSubmit}
      confirmLoading={loading}
      width={stateInfo ? 600 : 450}
    >
      <Spin spinning={Boolean(isFetching)}>
        {isError ? (
          <ErrorContent refetch={refetch} />
        ) : (
          !stateInfo ? (
          <Form>
            <FormItem label="Статус">
              {getFieldDecorator(fieldNames.status, {
                rules: [
                  {
                    required: true,
                    type: 'number',
                    message: 'Укажите статус',
                  },
                ],
              })(
                <Select placeholder="Выберите статус">
                  {data?.map((status) => (
                    <Option
                      key={status.id}
                      value={status.id}
                    >
                      {status.description}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>
          </Form>
         ) : (
          <InformationBlockModal typeMassActions={typeMassActionsText.state} count={requests.length} />
        )
        )}
      </Spin>
    </BaseModal>
  );
};

const ChangeState = createForm({ name: 'mass_actions_status' })(FormContainer);
export default ChangeState;
